import dateFinderApi from '../api/dateFinderApi';
import dateFinder from '../models/dateFinder';
import dateFinderDescription from '../models/dateFinderDescription';
import dateFinderMeetingType from '../models/dateFinderMeetingType';
import { generateParamsDateFinder, generateParams } from '../functions/utils';
import * as constant from '../constants/constants';
import { IParamsRequest } from 'redhotpie-shared-lib/interfaces/IAction';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

class DateFinderService {
  postDateFinderSearch(params: IParamsRequest): Promise<IApiResponse> {
    const body = generateParamsDateFinder(params);
    return dateFinderApi
      .postFilterDateFinder(body)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: {
                countSummary: dateFinder.mappingDataCountSummary(res.data.CountSummary),
                searchCriteria: dateFinder.mappingSearchCriteria(res.data.SearchCriteria),
                dates:
                  res.data.SearchSummary && res.data.SearchSummary.Dates ? dateFinder.mappingObjects(res.data.SearchSummary.Dates) : [],
              },
            };
          }
          return { success: res.success, data: { data: null } };
        }
        console.log('ERROR: dateFinderService/postDateFinderSearch:', res);
        return { success: true, data: [], message: res.data.message };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/postDateFinderSearch:', e);
        return { success: true, data: [], message: e };
      });
  }

  getDetailDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    return dateFinderApi
      .getDetailDateFinder(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: dateFinder.mappingObject(res.data),
            };
          }
          return { success: res.success, data: { data: null } };
        }
        console.log('ERROR: dateFinderService/getListDateFinder:', res);
        return {
          success: res.success,
          data: null,
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/getPhotoGallery:', e);
        return { success: false, data: null, message: e };
      });
  }

  getMyDateFinder(params?: IParamsRequest): Promise<IApiResponse> {
    const optionParams = params ? generateParams({ ...params }) : null;
    return dateFinderApi
      .getMyDateFinder(optionParams)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: dateFinder.mappingObjects(res.data.items),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: dateFinderService/getMyDateFinder:', res);
        return { success: res.success, data: [], message: res.data.message };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/getMyDateFinder:', e);
        return { success: false, data: [], message: e };
      });
  }

  getDateFinderInterests(id: string | number, params: IParamsRequest): Promise<IApiResponse> {
    const optionParams = params ? generateParams({ ...params, pageSize: 24 }) : null;
    return dateFinderApi
      .getDateFinderInterests(id, optionParams)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: true,
              data: dateFinder.mappingObjectsInterest(res.data.items, true),
            };
          }
          return { success: false, data: [] };
        }
        console.log('ERROR: dateFinderService/getDateFinderInterests:', res);
        return { success: false, data: [], message: res.message };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/getDateFinderInterests:', e);
        return { success: false, data: [], message: e };
      });
  }

  postFilterDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    return dateFinderApi
      .postFilterDateFinder(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: { data: res.data },
            };
          }
          return { success: res.success, data: { data: [] } };
        }
        console.log('ERROR: dateFinderService/postFilterDateFinder:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/postFilterDateFinder:', e);
        return { success: false, data: { data: [] }, message: e };
      });
  }

  postCreateDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    return dateFinderApi
      .postCreateDateFinder(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: dateFinder.mappingObjects(res.data.items),
            };
          }
          return { success: res.success, data: { data: [] } };
        }
        console.log('ERROR: dateFinderService/postCreateDateFinder:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/postCreateDateFinder:', e);
        return { success: false, data: { data: [] }, message: e };
      });
  }

  patchDeleteDateFinder(listId: number[]): Promise<IApiResponse> {
    return dateFinderApi
      .patchDeleteDateFinder(listId)
      .then(res => {
        if (res.success) {
          return { success: true };
        }
        console.log('ERROR: dateFinderService/patchDeleteDateFinder:', res);
        return { success: false, message: res.message };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/patchDeleteDateFinder:', e);
        return { success: false, message: e };
      });
  }

  postCreateDateFinderInterest(id: string): Promise<IApiResponse> {
    return dateFinderApi.postCreateDateFinderInterest(id).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.Result };
        }
        console.log('ERROR: dateFinderService/postCreateDateFinderInterest:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: dateFinderService/postCreateDateFinderInterest:', res);
      }
      return { success: false };
    });
  }

  postCreateDateFinderUnInterest(id: string): Promise<IApiResponse> {
    return dateFinderApi.postCreateDateFinderUnInterest(id).then(res => {
      try {
        if (res.success) {
          return { success: true, data: res.data.Result };
        }
        console.log('ERROR: dateFinderService/postCreateDateFinderUnInterest:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: dateFinderService/postCreateDateFinderUnInterest:', res);
      }
      return { success: false };
    });
  }

  getDateFinderDescriptions(): Promise<IApiResponse> {
    return dateFinderApi.getDateFinderDescriptions().then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: dateFinderDescription.mappingPropertyObjects(res.data.items),
          };
        }
        console.log('ERROR: dateFinderService/getDateFinderDescriptions:', res);
        return res;
      } catch (e) {
        console.log('ERROR: dateFinderService/getDateFinderDescriptions:', res);
        return res;
      }
    });
  }

  getDateFinderMeetingTypes(): Promise<IApiResponse> {
    return dateFinderApi.getDateFinderMeetingTypes().then(res => {
      try {
        if (res.success) {
          let data = dateFinderMeetingType.mappingPropertyObjects(res.data.items);
          data = dateFinderMeetingType.getIconObjects(data);
          return { success: true, data };
        }
        console.log('ERROR: dateFinderService/getDateFinderDescriptions:', res);
        return res;
      } catch (e) {
        console.log('ERROR: dateFinderService/getDateFinderDescriptions:', res);
        return res;
      }
    });
  }

  patchDeleteUserInterested(data: { idMyDate: string; interestId: string }): Promise<IApiResponse> {
    const params = {
      idMyDate: data.idMyDate,
      ListID: [data.interestId],
      Action: constant.PATCH_DATE_FINDER_INTERESTS.DELETE,
    };
    return dateFinderApi
      .patchDeleteUserInterested(params)
      .then(res => {
        if (res.success) {
          return { success: true };
        }
        console.log('ERROR: dateFinderService/patchDeleteUserInterested:', res);
        return { success: false, message: res.message };
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/patchDeleteUserInterested:', e);
        return { success: false, message: e };
      });
  }

  editDateFinder(params: IParamsRequest): Promise<IApiResponse> {
    return dateFinderApi
      .editDateFinder(params)
      .then(res => {
        if (res.success && res.data) {
          return {
            success: res.success,
            data: dateFinder.mappingObjects(res.data.items),
          };
        }
        return res;
      })
      .catch(e => {
        console.warn('ERROR: dateFinderService/editDateFinder:', e);
        return { success: false, message: e };
      });
  }

  deleteAllInterest(params: IParamsRequest): Promise<IApiResponse> {
    return dateFinderApi
      .deleteAllInterest(params)
      .then(res => res)
      .catch(e => {
        console.warn('ERROR: dateFinderService/deleteAllInterest:', e);
        return { success: false, message: e };
      });
  }
}

export default new DateFinderService();
